import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumPriceListGroupSortBy implements BaseEnumType {
  private static allValues: EnumPriceListGroupSortBy[] = []; // make sure this is top-most
  
  public static nameAsc = new EnumPriceListGroupSortBy(0, "NameAsc", "enum_price_list_group_sort_by_name_asc");
  public static nameDesc = new EnumPriceListGroupSortBy(1, "NameDesc", "enum_price_list_group_sort_by_name_desc");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumPriceListGroupSortBy.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNameAsc() { return this === EnumPriceListGroupSortBy.nameAsc; }
  public isNameDesc() { return this === EnumPriceListGroupSortBy.nameDesc; }

  public static getValues(): readonly EnumPriceListGroupSortBy[] {
    return EnumPriceListGroupSortBy.allValues;
  }

  public static getValuesExcept0(): readonly EnumPriceListGroupSortBy[] {
    return EnumPriceListGroupSortBy.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumPriceListGroupSortBy {
    const found = EnumPriceListGroupSortBy.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumPriceListGroupSortBy - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumPriceListGroupSortBy): EnumPriceListGroupSortBy {
    const found = name ? EnumPriceListGroupSortBy.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumPriceListGroupSortBy - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumPriceListGroupSortBy>): boolean {
    return this.key === other?.key;
  }
}